export default __webpack_public_path__ + "static/media/unmute.c23f8ed3.svg";